// extracted by mini-css-extract-plugin
module.exports = {"persona-view":"persona_flow_persona-view__Bnrzq","notice":"persona_flow_notice__eSKuH","button":"persona_flow_button__0rGKz","close":"persona_flow_close__rpMr7"};